<div *transloco="let t" class="m-auto max-w-sm">
  <h2 class="text-xl">{{ title() }}</h2>
  <p>{{ description() }}</p>
  <p class="text-error">{{ debugCode() }}</p>
</div>
